import styled from "styled-components";

export const StyledPreloaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledLoaderRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

export const StyledLoaderBtnRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    margin-top: 10px;
`;
